import { Component, Inject } from '../annotations';
import { ScrollService } from './scroll-service';

@Component({
	selector: 'header',
	template: require('./header.html'),
	style: require('./header.scss')
})
export class Header {
	mobileMenuVisible: boolean;

	constructor(@Inject('ScrollService') private scrollService: ScrollService) {
	}

	go(id: string): void {
		this.scrollService.scrollToElement(id);
		this.mobileMenuVisible = false;
	}

	toggleMobileMenu(): void {
		this.mobileMenuVisible = !this.mobileMenuVisible;
	}
}


/** WEBPACK FOOTER **
 ** ./app/common/header.ts
 **/